import { useEffect } from 'react';
import api from '@/lib/api';

/**
 * KeepAlive component that pings the backend every 2 minutes
 * to prevent container idle timeout and cold starts.
 * Also warms up the product and image endpoints.
 */
export function KeepAlive() {
  useEffect(() => {
    const PING_INTERVAL = 2 * 60 * 1000; // 2 minutes in milliseconds
    
    const keepAlive = async () => {
      const timestamp = new Date().toLocaleTimeString();
      try {
        // Ping health endpoint
        await api.get('/health');
        
        // Warm up products endpoint (also warms image cache)
        await api.get('/products?limit=5');
        
        // Warm up site settings (hero/CTA images)
        await api.get('/site-settings');
        
        console.debug(`[KeepAlive] ✅ Ping successful at ${timestamp}`);
      } catch (error) {
        console.debug(`[KeepAlive] ⚠️ Ping failed at ${timestamp}:`, error.message);
      }
    };

    // Initial warm-up on mount
    keepAlive();

    // Set up interval for recurring pings
    const intervalId = setInterval(keepAlive, PING_INTERVAL);

    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, []);

  // This component renders nothing
  return null;
}

export default KeepAlive;
